import create from 'zustand';

export type AuthError = 'input_error' | 'error' | 'not_found';
export enum AuthErrorEnum {
    InputError = 'input_error',
    Error = 'error',
    NotFound = 'not_found',
}

export type AuthErrorCallback = (reason: AuthError) => void;

interface AuthStore {
    bearer: string | null;
    isAuthenticated: boolean;
    isInvalidBearer: boolean;
    invalidBearerReason: AuthError | null;
    uuid: string | null;
    postcode: string | null;
    setEmailAndOrderBearer: (email: string, order: string) => string;
    setUuidAndPostcodeBearer: (uuid: string, postcode: string) => string;
    setInvalidBearer: AuthErrorCallback;
    authenticate: (uuid: string, postcode: string) => void;
    reset: () => void;
}

export const useAuthStore = create<AuthStore>(set => {
    return {
        bearer: null,
        isAuthenticated: false,
        isInvalidBearer: false,
        invalidBearerReason: null,
        autoLoginAttempted: false,
        uuid: null,
        postcode: null,
        setEmailAndOrderBearer: (email: string, order: string) => {
            const bearer = window.btoa(`${order}:${email}`);
            set({
                bearer,
                isAuthenticated: true,
                isInvalidBearer: false,
            });
            return bearer;
        },
        setUuidAndPostcodeBearer: (uuid: string, postcode: string) => {
            const bearer = window.btoa(`${uuid}:${postcode}`);
            set({
                bearer,
                isAuthenticated: true,
                isInvalidBearer: false,
            });
            return bearer;
        },
        setInvalidBearer: (reason: AuthError) => {
            set({
                isInvalidBearer: true,
                invalidBearerReason: reason,
                isAuthenticated: false,
                bearer: null,
            });
        },
        authenticate: (uuid: string, postcode: string) => {
            set({
                isAuthenticated: true,
                uuid,
                postcode,
            });
        },
        reset: () =>
            set({
                uuid: null,
                postcode: null,
                isAuthenticated: false,
            }),
    };
});
